export const daysDataShowing = "Showing data from the last 30 days";
export const ROWS_PER_PAGE = "Rows per page:";
export const FILTER_BY_WEBSITE = "Filter by website";
export const NO_COMPETITORS_ASSIGNED = "No Competitors Assigned";
export const SMALL_SCREENS_NOTIFICATION = {
    title: 'Desktop experience recommended',
    description: 'InsightHub is optimized for desktop screens. For the best experience, please switch to a desktop or laptop.',
    icon: 'svg/desktop.svg'
}